// STORE/Features/permisoSlice.ts
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import CatPermisos from '../../../Services/Catalogos/CatPermisos';
import { DTOPermiso } from '../../../Componest/Catalogos/CatPermisos/DTO/DTOPermiso';

interface PermisoState {
  permisosPorEmpleado: Record<string, DTOPermiso[]>;
  cargando: boolean;
  error: string | null;
}

const initialState: PermisoState = {
  permisosPorEmpleado: {},
  cargando: false,
  error: null
};

// 🟢 Obtener permisos por empleado
export const fetchPermisosPorEmpleado = createAsyncThunk(
  'permiso/fetchPorEmpleado',
  async (numEmpleado: string) => {
    const res = await CatPermisos.GetPermisosPorEmpleado(numEmpleado);
    return { numEmpleado, permisos: res.data as DTOPermiso[] };
  }
);

// 🟢 Insertar un permiso
export const insertarPermiso = createAsyncThunk(
  'permiso/insertar',
  async ({ permiso, correoSupervisor }: { permiso: DTOPermiso; correoSupervisor: string }, { dispatch }) => {
    await CatPermisos.PosInsertarPermiso(permiso);

    // Enviar notificación por correo (opcional)
    if (permiso.estado === 'Pendiente' && correoSupervisor) {
      const notificacion = {
        id: 0,
        numEmpleado: permiso.numEmpleado,
        nombreEmpleado: permiso.nombreEmpleado,
        correo: correoSupervisor,
        motivo: permiso.motivo,
        fechaPermiso: permiso.fechaPermiso,
        estado: permiso.estado , 
        observaciones: permiso.observaciones || ''
      };
      try {
        await CatPermisos.EnviarCorreoPermiso(notificacion);
      } catch (error) {
        console.error('Error al enviar correo:', error);
      }
    }

    // Recargar permisos del empleado
    dispatch(fetchPermisosPorEmpleado(permiso.numEmpleado));

    return permiso;
  }
);

const permisoSlice = createSlice({
  name: 'permiso',
  initialState,
  reducers: {
    // En caso de que quieras actualizar permiso individualmente
    actualizarPermisoEnLista: (state, action) => {
      const permisoActualizado = action.payload as DTOPermiso;
      const lista = state.permisosPorEmpleado[permisoActualizado.numEmpleado];
      if (!lista) return;
      const index = lista.findIndex(p => p.id === permisoActualizado.id);
      if (index !== -1) {
        lista[index] = permisoActualizado;
      }
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchPermisosPorEmpleado.fulfilled, (state, action) => {
        const { numEmpleado, permisos } = action.payload;
        state.permisosPorEmpleado[numEmpleado] = permisos;
        state.cargando = false;
      })
      .addCase(fetchPermisosPorEmpleado.pending, (state) => {
        state.cargando = true;
        state.error = null;
      })
      .addCase(fetchPermisosPorEmpleado.rejected, (state, action) => {
        state.cargando = false;
        state.error = action.error.message || 'Error al cargar permisos';
      })

      .addCase(insertarPermiso.pending, (state) => {
        state.cargando = true;
        state.error = null;
      })
      .addCase(insertarPermiso.fulfilled, (state) => {
        state.cargando = false;
      })
      .addCase(insertarPermiso.rejected, (state, action) => {
        state.cargando = false;
        state.error = action.error.message || 'Error al insertar permiso';
      });
  }
});

export const { actualizarPermisoEnLista } = permisoSlice.actions;
export default permisoSlice.reducer;
